import {useParams} from 'react-router-dom'
import React, { useState } from 'react';

import {SJCliTerrainCom} from '../containers'                
function SJCliTerrainComPage() {
    //we are inet so id is not passed
    console.log('SV*****SJCliTerrainComPage  crusies))))***')
    let { id } = useParams();
    let svparams = { 'id': id}
    console.log('SVCLI Crusies)))****')
    console.log('SV**WE CHANGE ***SJCliTerrainComPage',svparams)
    
    return (
        <SJCliTerrainCom svparams={svparams} ></SJCliTerrainCom>
        
    );
}
export default SJCliTerrainComPage